import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function Vendor ( props ) {

    return <BasicCrudScreenType id="Vendor" table="Vendor" view="VwVendor" />;

}

export default Vendor;
